import React from 'react';
import PropTypes from 'prop-types';
import { COLORS } from 'styleguide';

import { ROLES_OBJECT } from 'utils/roles';
import { REJECT_REASONS } from 'admin-moderator/components/MaterialCardModal';

import SocialLinks from 'admin-moderator/components/SocialLinks';
import Avatar from 'components/Avatar';

import { ReactComponent as Time } from 'icons/Time.svg';

import SimpleList from 'styled/SimpleList';
import Label from 'styled/Label';

import StoryItemWrapper from './StoryItemWrapper';
import Header from './Header';
import ChangeHeading from './ChangeHeading';
import StatusBlock from './StatusBlock';
import ChangeStatusBox from './ChangeStatusBox';
import DateBox from './DateBox';
import ListItem from './ListItem';
import ChangeValue from './ChangeValue';

const EVENTS = {
  create: 'Создан',
  update: 'Изменён',
  accepted: 'Одобрен',
  rejected: 'Отклонён',
};

const CHANGES = {
  price: 'Цена',
  title: 'Название',
  description: 'Описание',
};

class StoryItem extends React.PureComponent {
  get statusColor() {
    if (this.props.objectChanges.status && this.props.objectChanges.status[1] === 'accepted') return COLORS.success;

    if (this.props.objectChanges.status && this.props.objectChanges.status[1] === 'rejected') return COLORS.error;

    return '#fff';
  }

  get materialStatus() {
    if (this.props.objectChanges.status && this.props.objectChanges.status[1]) return EVENTS[this.props.objectChanges.status[1]];

    return EVENTS[this.props.event] || this.props.event;
  }

  render() {
    return (
      <StoryItemWrapper>
        <Header>
          <Avatar
            name={this.props.name}
            size="56px"
            url={this.props.avatarUrl}
            hasBorder
          />

          <div style={{ flexGrow: 1, margin: '0 16px' }}>
            <ChangeHeading>{this.props.name}</ChangeHeading>

            {this.props.roles.map(role => (
              <StatusBlock key={role}>
                {ROLES_OBJECT[role] || role}
              </StatusBlock>
            ))}

            {this.props.socialLinks && this.props.socialLinks.length > 0 && (
              <SocialLinks socialLinks={this.props.socialLinks} />
            )}
          </div>

          <DateBox>
            <span style={{ marginRight: '8px' }}><Time /></span>

            {new Date(this.props.updatedAt * 1000).toLocaleString('ru-RU', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              timeZone: 'Europe/Moscow',
            })}
          </DateBox>
        </Header>

        <div style={{ padding: '0 15px 25px', marginTop: '25px' }}>
          <ChangeHeading>
            Материал

            <ChangeStatusBox color={this.statusColor}>
              {this.materialStatus}
            </ChangeStatusBox>
          </ChangeHeading>

          {this.props.objectChanges && !this.props.objectChanges.status && (
            <SimpleList style={{ padding: '15px 0' }}>
              {Object.keys(this.props.objectChanges).map((change) => {
                if (change === 'updatedAt') return null;
                if (change === 'createdAt') return null;

                return (
                  <ListItem>
                    <Label>{CHANGES[change] || change}</Label>

                    <ChangeValue>{String(this.props.objectChanges[change][1])}</ChangeValue>
                  </ListItem>
                );
              })}
            </SimpleList>
          )}

          {this.props.objectChanges.status
            && this.props.objectChanges.status[1] === 'rejected'
            && this.props.objectChanges.explain
            && this.props.objectChanges.explain[1] && (
            <SimpleList style={{ padding: '15px 0' }}>
              <ListItem>
                <Label>Причина отклонения</Label>

                <ChangeValue>
                  {REJECT_REASONS[this.props.objectChanges.explain[1]] || this.props.objectChanges.explain[1]}
                </ChangeValue>
              </ListItem>
            </SimpleList>
          )}
        </div>
      </StoryItemWrapper>
    );
  }
}

StoryItem.propTypes = {
  name: PropTypes.string,
  avatarUrl: PropTypes.string,
  roles: PropTypes.arrayOf(PropTypes.string),
  socialLinks: PropTypes.arrayOf(PropTypes.shape({
    provider: PropTypes.string,
    socialLink: PropTypes.string,
  })),
  event: PropTypes.oneOf(['update', 'create', 'destroy']),
  updatedAt: PropTypes.number,
  objectChanges: PropTypes.shape(),
};

StoryItem.defaultProps = {
  name: '',
  avatarUrl: '',
  roles: [],
  socialLinks: [],
  event: '',
  updatedAt: undefined,
  objectChanges: {},
};

export default StoryItem;
